<div class="ajustar-pontuacao">
  <header class="page-header">
    <div>
      <h1>Ajustar Pontuação</h1>
      <p>Pedidos faturados com item sem pontuação, mas com pontuação configurada no produto.</p>
    </div>

    <div class="filters">
      <label>
        Buscar a partir do dia
        <input type="date" [(ngModel)]="dataDoFiltro" />
      </label>
      <button type="button" class="btn-primary" (click)="carregar()" [disabled]="carregando || ajustando">Atualizar</button>
      <button type="button" class="btn-success" (click)="ajustarTodas()" [disabled]="carregando || ajustando || itens.length === 0">Ajustar Todas</button>
    </div>
  </header>

  <section class="cards">
    <div class="metric-card">
      <span>Itens pendentes</span>
      <strong>{{ itens.length }}</strong>
    </div>
    <div class="metric-card">
      <span>Pontuação a gerar</span>
      <strong>{{ formatarNumero(totalPontuacao) }}</strong>
    </div>
  </section>

  <section class="panel">
    <div class="panel-title">
      <h2>Itens com pontuação zerada</h2>
      @if (carregando || ajustando) {
        <span>Processando...</span>
      }
    </div>

    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Pedido</th>
            <th>NF</th>
            <th>Dt. Faturamento</th>
            <th>Cliente</th>
            <th>Produto</th>
            <th class="number">Pontuação a gerar</th>
            <th class="action">Ação</th>
          </tr>
        </thead>
        <tbody>
          @for (item of itens; track item.idItem) {
            <tr>
              <td>{{ item.orderIdApp }}</td>
              <td>{{ item.numeroNf || '-' }}</td>
              <td>{{ item.dtFaturamentoErp | date:'dd/MM/yyyy' }}</td>
              <td>{{ item.cliente }}</td>
              <td>{{ item.produto }}</td>
              <td class="number">{{ formatarNumero(item.pontuacaoAGerar) }}</td>
              <td class="action">
                <button type="button" class="btn-line" (click)="ajustarNota(item)" [disabled]="ajustando">Ajustar NF</button>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="7" class="empty">Nenhum item pendente encontrado para o filtro informado.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </section>
</div>
